import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-module-selector',
  standalone: true,
  imports: [CommonModule, RouterModule, CardModule, ButtonModule],
  templateUrl: './module-selector.component.html',
  styleUrls: ['./module-selector.component.css']
})
export class ModuleSelectorComponent {
  constructor(private router: Router) {}

  goToCAC(): void {
    localStorage.setItem('selectedModule', 'CAC');
    this.router.navigate(['/cac/dashboard']);
  }

  goToCAS(): void {
    localStorage.setItem('selectedModule', 'CAS');
    this.router.navigate(['/cas/dashboard']);
  }
}

